export default __webpack_public_path__ + "static/media/eventDashboard_psm.84f4d270.svg";